// extracted by mini-css-extract-plugin
export var card = "projectCard-module--card--IMD53";
export var label = "projectCard-module--label--4lTGt";
export var title = "projectCard-module--title--1YQ8l";
export var partnership = "projectCard-module--partnership--8-pqn";
export var angle = "projectCard-module--angle--V8cUW";
export var slideUp = "projectCard-module--slideUp--RDG3t";
export var slideUpLarge = "projectCard-module--slideUpLarge--r3SsK";